
// export const SERVER_HOST = 'http://192.168.1.173:8082';
// export const SERVER_HOST = 'https://hgtc.cn.utools.club';
// export const SERVER_HOST = 'http://hgtc.cn.utools.club';
export const SERVER_HOST = '/api';
